<!--
주문하기 > 주문정보 입력
------------------------------------
-->
<template>
    <app-layout-group icon="edit" header="주문정보작성">
        <div slot="body">
            <div class="uk-flex uk-flex-center">
                <div class="uk-width-medium uk-margin-right">
                    <!-- 주문정보 -->
                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="text"

                        v-model="order.buy_order_code"
                        label="해외주문번호"
                        placeholder=""

                        :validate-rules="{required: true}"
                        required
                    > </app-input-ex>

                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="text"

                        v-model="order.order_date"
                        label="주문일"
                        placeholder="e.g. 2019-01-01"

                    > </app-input-ex>

                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="text"

                        v-model="order.order_url"
                        label="주문URL(도메인)"
                        placeholder="e.g. amazon.com"

                    > </app-input-ex>

                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="text"

                        v-model="order.order_email"
                        label="주문이메일"
                        placeholder="e.g. 해외사이트의 오더메일을 수신할 이메일"

                    > </app-input-ex>

                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="text"

                        v-model="order.order_id"
                        label="주문ID"
                        placeholder="e.g. 해외사이트의 ID"

                    > </app-input-ex>
                </div>

                <div class="uk-width-medium uk-margin-right">
                    <!-- 배송지 -->
                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="radio"
                        :options="shippingCenterOptions"

                        v-model="order.shipping_center"
                        label="배송지"
                        placeholder=""
                    > </app-input-ex>
                </div>

                <div class="uk-width-medium">


                    <!-- 결제정보 -->
                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="writable-select"
                        :options="paymentMethodOptions"

                        v-model="order.payment_method"
                        label="결제방법(카드)"
                        placeholder=""
                    > </app-input-ex>

                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="text"

                        v-model="order.payment_price"
                        label="결제금액"
                        :placeholder="regionCurrency"
                    > </app-input-ex>

                    <app-input-ex
                        class="uk-margin-small-bottom"
                        type="textarea"
                        :textarea-rows="5"

                        v-model="order.payment_memo"
                        label="결제추가정보"
                        placeholder="배송비, TAX, 프로모션등의 내용을 기록"
                    > </app-input-ex>
                </div>
            </div>
        </div>
    </app-layout-group>
</template>

<script>
    export default {
        props: {
            // 지역화폐
            regionCurrency: String,

            // 지역ID
            regionId: Number,

            // 영업소ID
            agentId: Number,

            // 사용자ID
            userId: Number,

            /**
             * (object) 오더정보
             */
            order: {
                type: Object,
            },

            /**
             * (array) 배송지 옵션
             */
            shippingCenterOptions: {
                type: Array,
            },

            /**
             * (array) payment_method 옵션
             */
            paymentMethodOptions: {
                type: Array,
            },
        },
        data: function () {
            return {

            };
        },

        computed: {
        },
        methods: {


        }
    }
</script>

<style lang="scss" scoped>
</style>